import React from "react";
import DashboardHeader from "../../../../components/dashboardHeader";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../../components/drawer";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../lib/redux/slices/activeTabSlice";
import { useNavigate } from "react-router-dom";
import TuitonFee from "./TuitonFee";
import AdmissionFee from "./AdmissionFee";

const tabs = [
  {
    label: "Tuition Fee (Monthly)",
    value: "tuition_fee_monthly",
  },
  {
    label: "Admission Fee",
    value: "purchase_invoice",
  },
];

const EducatationDbFeesStructurePage = () => {
  const navigate = useNavigate();
  const dispacth = useDispatch();
  const activeTab = useSelector((state) => state.activeTabReducer.tabs);

  const handleChangeTab = (value) => {
    dispacth(setActiveTab({ ...activeTab, fess_structure: value }));
  };
  return (
    <DashboardHeader>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.5}>
          <DynamicTabsDrawer
            primaryHeading={"Admission Section"}
            tabs={tabs}
            activeTab={activeTab.fess_structure}
            showBackBtn={true}
            handleBack={() => navigate("/dashboard/education")}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.5}>
          {activeTab.fess_structure === "tuition_fee_monthly" ? (
            <TuitonFee />
          ) : activeTab.fess_structure === "purchase_invoice" ? (
            <AdmissionFee />
          ) : null}
        </Grid>
      </Grid>
    </DashboardHeader>
  );
};

export default EducatationDbFeesStructurePage;
